const adminOnlyPaths = new Set([
  '/consumptionManage/ocrHistory',
  '/brandManage/carBrandList',
  '/productManage/functionList',
  '/systemManage/reportTemplate',
]);

export function canAccessPage(path, adminAuthorized) {
  return !adminOnlyPaths.has(path) || adminAuthorized === true;
}

export function filterAccessibleMenus(items, adminAuthorized) {
  return items.filter(item => canAccessPage(item.path, adminAuthorized)).map(item => ({
    ...item,
    ...(Array.isArray(item.children) ? { children: filterAccessibleMenus(item.children, adminAuthorized) } : {}),
  }));
}
